import {Mapper} from '@s-ui/domain'

export class FaqStructuredDataSeoMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Function} deps.structuredDataValueObjectFactory
   * */
  constructor({config, structuredDataValueObjectFactory}) {
    super()
    this._config = config
    this._structuredDataValueObjectFactory = structuredDataValueObjectFactory
  }

  /**
   * https://schema.org/
   * @return {StructuredDataValueObject}
   */
  map = ({seoFaqDataStructure}) => {
    return this._structuredDataValueObjectFactory(seoFaqDataStructure)
  }
}
